import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import moment from 'moment';

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public notices: any = [];
    public trafficName = "대전";
    public traffic_status: any = 'ing'
    public traffic: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("대시보드 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.render();
    }

    public event: any = {
        data: {},
        selected: async (location) => {
            this.trafficName = location.name;
            this.traffic = null;
            this.traffic_status = 'ing';
            await this.service.render();

            const { code, data } = await wiz.call("loadTraffic", { id: location.id });
            let traffic = data;
            await this.service.render();

            if (traffic) {
                for (let i = 0; i < traffic._time.length; i++)
                    traffic._time[i] = (moment(traffic._time[i]).add(9, 'hours')).format("YYYY-MM-DD HH:mm:ss");

                this.traffic = {
                    category: traffic._time,
                    series: [{
                        name: 'IN',
                        data: traffic._in
                    }, {
                        name: 'OUT',
                        data: traffic._out
                    }]
                };

                this.traffic_status = "success";
            } else this.traffic_status = "error";
            await this.service.render();
        }
    };
}

export default PageDashboardComponent;